/* eslint-disable max-lines-per-function */
import { StyledPharmindexLogo } from './StyledPharmindexLogo';

const PharmindexLogo = (): JSX.Element => (
   <StyledPharmindexLogo width='96' height='18' viewBox='0 0 96 18' fill='none'>
      <g clipPath='url(#clip0_6534_180)'>
         <path d='M0 0H1.72924H94.2384H96V18H94.2356H1.74599H0V15.9435V2.04404V0Z' fill='#FCBB00' />
         <path
            d='M94.2382 0H95.9997V18H94.2354C96.3152 17.0336 95.9697 15.4344 95.9707 13.4679L95.9716 9.73923L95.9707 5.09698C95.9702 4.13937 96.0452 2.59169 95.8413 1.65622C95.6805 0.917773 94.9075 0.327522 94.2382 0Z'
            fill='#F7F6F7'
         />
         <path
            d='M0 15.9436C0.311114 16.8998 0.591127 17.4179 1.52905 17.896C1.60055 17.9324 1.67287 17.9671 1.74599 18.0001H0V15.9436Z'
            fill='#F7F6F7'
         />
         <path
            d='M0 0H1.72924C0.750811 0.488212 0.389916 0.877206 0.038309 1.92607C0.0252065 1.96528 0.0124363 2.00461 0 2.04404V0Z'
            fill='#F7F6F7'
         />
         <path
            d='M65.3613 4.50333C66.1634 4.51158 67.3455 4.55595 68.1232 4.50174C71.1349 4.29184 74.1607 5.27169 74.2999 8.83214C74.3543 10.2207 73.9737 11.1733 73.009 12.2102C71.472 13.5876 69.918 13.5017 68.0252 13.4984L65.3618 13.4974L65.3613 4.50333Z'
            fill='#2B2A2A'
         />
         <path
            d='M67.4209 6.2012C68.6893 6.1985 70.4443 5.99727 71.4193 6.94848C72.5523 8.05368 72.4853 9.86723 71.4521 11.0153C70.3698 12.0224 68.8351 11.8014 67.4209 11.7941V6.2012Z'
            fill='#FCBB00'
         />
         <path
            d='M32.2793 4.50268C33.795 4.52102 36.3878 4.33189 37.7735 4.74748C40.4672 5.55535 40.8605 9.21243 38.1707 10.6133C38.7562 11.542 39.513 12.5818 40.1448 13.4947L39.4639 13.4955L37.9262 13.4973L36.218 10.9933L34.3169 10.9919L34.3135 13.4978L32.2787 13.4979C32.2362 10.5436 32.2701 7.46477 32.2793 4.50268Z'
            fill='#2B2A2A'
         />
         <path
            d='M34.3176 6.20182C35.5813 6.18946 37.9046 5.85693 37.8913 7.72452C37.8874 8.26883 37.7988 8.52884 37.4267 8.92318C36.6925 9.48843 35.2466 9.3369 34.3154 9.32932L34.3176 6.20182Z'
            fill='#FCBB00'
         />
         <path
            d='M49.2241 4.50391L50.9065 4.50451L50.9182 13.4977L48.9926 13.4978L48.9902 11.4396L48.9841 8.1046L46.3663 12.5501L45.4439 12.5519L42.8473 8.22851C42.7933 9.89091 42.8383 11.8156 42.838 13.4979L40.9134 13.4978L40.9102 4.50392L42.5987 4.50547C43.7317 6.33487 44.8047 8.2936 45.9609 10.0938C46.2224 9.53555 46.8459 8.54152 47.1827 7.96846C47.8554 6.80902 48.536 5.65413 49.2241 4.50391Z'
            fill='#2B2A2A'
         />
         <path
            d='M4.36075 4.50387C6.51282 4.52292 10.707 3.93513 11.749 6.27326C12.6658 8.33052 11.7029 10.2668 9.5514 10.8683C8.76094 11.0726 7.27543 11.024 6.42179 11.0231L6.41987 13.4962L4.36035 13.4972L4.36075 4.50387Z'
            fill='#2B2A2A'
         />
         <path
            d='M6.42123 6.20185C7.23344 6.19546 8.85803 6.02929 9.50242 6.6051C10.1883 7.2179 10.138 8.19791 9.55919 8.89001C8.80722 9.47937 7.37659 9.32533 6.41992 9.31462L6.42123 6.20185Z'
            fill='#FCBB00'
         />
         <path
            d='M61.9301 4.50317L63.9715 4.50515C63.9302 7.46394 63.9654 10.5122 63.9682 13.4792C63.5618 13.5241 62.7312 13.499 62.2929 13.4977C61.8049 12.9626 61.2265 12.2115 60.7615 11.6382C59.7954 10.4382 58.8227 9.24343 57.844 8.05405L57.8374 13.4976L55.8143 13.4979L55.8105 4.50384L57.4887 4.50573C57.9045 4.94119 58.4829 5.71514 58.878 6.19314C59.907 7.43883 60.9026 8.75136 61.9563 9.97427C61.9291 8.1585 61.9357 6.3208 61.9301 4.50317Z'
            fill='#2B2A2A'
         />
         <path
            d='M25.5761 4.50244L27.6156 4.50471C27.815 5.10458 28.6718 6.92656 28.9716 7.60133L31.5856 13.4969L29.4319 13.4984C29.1574 12.8947 28.8858 12.1808 28.6329 11.56L27.6326 11.561L24.5121 11.5615L23.7131 13.4982L21.6123 13.4967L25.5761 4.50244Z'
            fill='#2B2A2A'
         />
         <path
            d='M26.552 6.57935C26.7245 6.80946 27.8024 9.53419 27.9876 9.9912L26.6483 9.9876L25.1494 9.98746C25.6287 8.85639 26.0962 7.72031 26.552 6.57935Z'
            fill='#FCBB00'
         />
         <path
            d='M12.8398 4.50244L14.8741 4.50412L14.8779 8.05877L18.9347 8.05181L18.9337 4.50391L20.9653 4.50516C20.9638 6.91004 21.0002 10.8773 20.9699 13.4235C20.9442 13.4514 20.9219 13.4756 20.9031 13.496L18.9393 13.4974L18.9363 9.79037L14.8834 9.79966C14.851 10.9812 14.8807 12.3082 14.881 13.4988L12.848 13.4979L12.8398 4.50244Z'
            fill='#2B2A2A'
         />
         <path
            d='M75.1778 4.50293C77.3978 4.52734 79.66 4.50469 81.8832 4.50493L81.8462 6.17315L77.2032 6.17888L77.1971 8.1431L81.3329 8.1378L81.3292 9.72734L77.3321 9.74667L77.2637 9.75581C77.1278 9.9261 77.169 11.4866 77.1676 11.8186C78.7098 11.8662 80.4845 11.825 82.0445 11.825L82.0337 13.497L75.1553 13.4967L75.1778 4.50293Z'
            fill='#2B2A2A'
         />
         <path
            d='M89.1543 4.50366L91.3963 4.50896C90.3744 5.82905 89.278 7.46553 88.2828 8.84746C88.9996 9.83689 89.7107 10.8303 90.4166 11.8275C90.6655 12.1752 91.3686 13.1176 91.5397 13.4417L91.5003 13.4895L91.3246 13.4961L89.24 13.4981C88.5566 12.5823 87.7555 11.3435 87.088 10.3765C86.3877 11.3507 85.6522 12.4933 84.9721 13.4973L82.6143 13.4981L85.896 8.92718C85.0396 7.58348 83.7271 5.83838 82.7844 4.50547L85.1155 4.50422L87.163 7.41978C87.6955 6.55066 88.558 5.37062 89.1543 4.50366Z'
            fill='#2B2A2A'
         />
         <path d='M52.3627 8.06104L54.3624 8.06468L54.3605 13.4966L52.3604 13.4973L52.3627 8.06104Z' fill='#2B2A2A' />
         <path
            d='M52.3604 4.50293L54.3633 4.50507L54.3586 6.35678C53.6972 6.34972 53.0227 6.35782 52.3604 6.35882V4.50293Z'
            fill='#2B2A2A'
         />
      </g>
      <defs>
         <clipPath id='clip0_6534_180'>
            <rect width='96' height='18' fill='white' />
         </clipPath>
      </defs>
   </StyledPharmindexLogo>
);

export { PharmindexLogo };
